module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card-header mb2"
  }, [_c('div', {
    staticClass: "suggestion-author-info"
  }, [_c('div', {
    staticClass: "avatar-circle avatar-size ma1",
    style: ({
      backgroundImage: 'url(' + _vm.suggestion.author.avatar_url + ')',
      'background-size': 'cover',
      'background-position': 'center',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "suggestion-author-div ph2"
  }, [_c('span', {
    staticClass: "suggestion-author b truncate-text"
  }, [_vm._v("\n          " + _vm._s(_vm.suggestion.author.name) + "\n        ")]), _vm._v(" "), (_vm.suggestion.author.job_title) ? _c('span', [_vm._v("\n          " + _vm._s('(' + _vm.suggestion.author.job_title + ')') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "suggestion-date i"
  }, [_vm._v(" " + _vm._s(_vm.suggestion_date) + " ")])])]), _vm._v(" "), (_vm.isParlayAdmin) ? _c('div', {
    staticClass: "suggestion-options b"
  }, [(_vm.suggestion.is_draft) ? _c('span', {
    staticClass: "suggestion-draft"
  }, [_vm._v(" Draft ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu",
    staticStyle: {
      "width": "30px"
    }
  }, [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('div', {
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('pl-button', {
    staticClass: "pl-icon pl-no-margin"
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v"
  })])], 1), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    on: {
      "click": _vm.editSuggestion
    }
  }, [_c('span', [_vm._v(" Edit ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.deleteSuggestion
    }
  }, [_c('span', [_vm._v("Delete")])])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isParlayAdmin && (_vm.isNewSuggestion || _vm.sugestionNotRead)) ? _c('div', {
    staticClass: "right suggestion-new"
  }, [_c('span', {
    staticClass: "green-new"
  }, [_vm._v("\n        New\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.listOfNames !== '') ? _c('div', {
    staticClass: "card-suggestion-destination mt2 mb3"
  }, [_c('div', {
    staticStyle: {
      "color": "pl-secondary"
    }
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v(" Email sent to: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.listOfNames) + " ")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#454444"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.suggestion.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e4078664!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/suggestions/suggestionCard.vue
// module id = 2016
// module chunks = 61